import DOMPurify from "isomorphic-dompurify";

import { ALLOWED_URI_REGEXP } from "./allowed-uris";

// 번역 문자열에 포함될 수 있는 HTML 을 허용 태그/속성만 남기고 정화한다.
export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    ALLOWED_ATTR: ["style", "href", "src", "alt", "width", "height"],
    ALLOWED_TAGS: ["span", "b", "a", "img", "font", "br"],
    ALLOWED_URI_REGEXP,
  });
};
